var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"iv-fc-65 iv-main-hover-color iv-operate-item iv-pull-left iv-pointer uit-add-list",on:{"click":function($event){return _vm.expandParent('view', _vm.item)}}},[_vm._v(" 查看详情 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }